import React, { useEffect, useState, useRef } from 'react';
import { PlayIcon, ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
import { useSpotify } from './SpotifyContext';
const visualiserVideos = [{
  id: 1,
  title: 'ROSANNA',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-27-at-13.10.17.png',
  videoUrl: 'https://www.youtube.com/watch?v=sQWgEIjRyU0'
}, {
  id: 2,
  title: 'THE MOON ON THE RIVER',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-28-at-15.42.43.png',
  videoUrl: 'https://www.youtube.com/watch?v=hVWFvdkeBuo'
}, {
  id: 3,
  title: 'ENGLISH ROSE',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-27-at-13.29.44.png',
  videoUrl: 'https://www.youtube.com/watch?v=nT3twaiX5cw'
}, {
  id: 4,
  title: 'HOW IT FEELS TO LOVE YOU LATELY',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-27-at-13.30.22.png',
  videoUrl: 'https://www.youtube.com/watch?v=nj0ML9Rutu8'
}, {
  id: 5,
  title: 'SUNSET ON SATURN',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-28-at-15.44.55-1.png',
  videoUrl: 'https://www.youtube.com/watch?v=1m8q0IDf9fg'
}, {
  id: 6,
  title: 'EXHIBITION',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-28-at-15.47.18.png',
  videoUrl: 'https://www.youtube.com/watch?v=VrL6ti7tKME'
}, {
  id: 7,
  title: 'A HUMAN BEING OF PLANET EARTH',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-27-at-13.09.08.png',
  videoUrl: 'https://www.youtube.com/watch?v=MBInrN8YtuU'
}, {
  id: 8,
  title: "I'M ON THE RUN",
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-27-at-13.09.31.png',
  videoUrl: 'https://www.youtube.com/watch?v=i7fJWWbABTA'
}, {
  id: 9,
  title: 'MY LAST MIDNIGHT',
  thumbnail: 'https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-27-at-13.09.31.png',
  videoUrl: 'https://www.youtube.com/watch?v=jZdIih7liZI'
}];
const Visualisers = () => {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [showBackgroundAnimations, setShowBackgroundAnimations] = useState(false);
  const videosPerPage = 4;
  const totalPages = Math.ceil(visualiserVideos.length / videosPerPage);
  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const handleVideoClick = (videoUrl: string) => {
    const videoId = new URL(videoUrl).searchParams.get('v');
    if (videoId) {
      // Trigger background animations
      setShowBackgroundAnimations(true);
      // Scroll to top when selecting a video on mobile
      if (isMobile) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      // Show the video after a short delay
      setTimeout(() => {
        setActiveVideo(videoId);
        // Keep animations running for a bit after video loads
        setTimeout(() => {
          setShowBackgroundAnimations(false);
        }, 5000);
      }, 300);
    }
  };
  const closeVideo = () => {
    setActiveVideo(null);
  };
  const nextPage = () => {
    setCurrentPage(prev => (prev + 1) % totalPages);
  };
  const prevPage = () => {
    setCurrentPage(prev => (prev - 1 + totalPages) % totalPages);
  };
  const displayedVideos = visualiserVideos.slice(currentPage * videosPerPage, (currentPage + 1) * videosPerPage);
  return <section className="pt-28 md:pt-36 pb-16" data-id="element-704">
      <div className="max-w-6xl mx-auto" data-id="element-705">
        <h2 className="text-5xl font-bold mb-12 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-706">
          VISUALISERS
        </h2>

        {/* Background Animation Elements */}
        {showBackgroundAnimations && <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-707">
            {/* Spaceship 1 */}
            <div className="absolute w-16 h-8 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full opacity-70 animate-spaceship1" data-id="element-708">
              <div className="absolute -right-2 top-1/2 w-4 h-2 bg-orange-500 rounded-l-full transform -translate-y-1/2 animate-pulse" data-id="element-709"></div>
              <div className="absolute top-1/2 left-1/2 w-3 h-3 bg-blue-300 rounded-full transform -translate-x-1/2 -translate-y-1/2" data-id="element-710"></div>
            </div>
            {/* Spaceship 2 */}
            <div className="absolute w-12 h-6 bg-gradient-to-r from-blue-600 to-cyan-400 rounded-full opacity-70 animate-spaceship2" data-id="element-711">
              <div className="absolute -right-2 top-1/2 w-3 h-1.5 bg-yellow-400 rounded-l-full transform -translate-y-1/2 animate-pulse" data-id="element-712"></div>
            </div>
            {/* Alien 1 */}
            <div className="absolute animate-alien1" data-id="element-713">
              <div className="w-10 h-14 relative" data-id="element-714">
                <div className="w-10 h-6 bg-green-500 rounded-full opacity-80" data-id="element-715"></div>
                <div className="absolute top-2 left-2 w-2 h-2 bg-black rounded-full" data-id="element-716"></div>
                <div className="absolute top-2 right-2 w-2 h-2 bg-black rounded-full" data-id="element-717"></div>
                <div className="absolute top-4 left-1/2 transform -translate-x-1/2 w-4 h-1 bg-black rounded-full" data-id="element-718"></div>
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-4 h-8 bg-green-500 rounded-b-lg" data-id="element-719"></div>
              </div>
            </div>
            {/* Alien 2 */}
            <div className="absolute animate-alien2" data-id="element-720">
              <div className="w-8 h-12 relative" data-id="element-721">
                <div className="w-8 h-5 bg-purple-500 rounded-t-full opacity-80" data-id="element-722"></div>
                <div className="absolute top-1 left-1.5 w-1.5 h-1.5 bg-yellow-300 rounded-full" data-id="element-723"></div>
                <div className="absolute top-1 right-1.5 w-1.5 h-1.5 bg-yellow-300 rounded-full" data-id="element-724"></div>
                <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-3 h-0.5 bg-yellow-300 rounded-full" data-id="element-725"></div>
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-3 h-7 bg-purple-500 rounded-b-lg" data-id="element-726"></div>
              </div>
            </div>
            {/* Dancing Star Person */}
            <div className="absolute animate-dancer" data-id="element-727">
              <div className="w-12 h-16 relative" data-id="element-728">
                <div className="w-6 h-6 bg-yellow-300 rounded-full opacity-90 mx-auto animate-pulse" data-id="element-729"></div>
                <div className="w-8 h-1 bg-yellow-300 absolute top-6 left-2 rotate-45 animate-dancing-arm1" data-id="element-730"></div>
                <div className="w-8 h-1 bg-yellow-300 absolute top-6 right-2 -rotate-45 animate-dancing-arm2" data-id="element-731"></div>
                <div className="w-1 h-6 bg-yellow-300 absolute bottom-0 left-1/2 transform -translate-x-1/2" data-id="element-732"></div>
                <div className="w-6 h-1 bg-yellow-300 absolute bottom-0 left-3 rotate-45 animate-dancing-leg1" data-id="element-733"></div>
                <div className="w-6 h-1 bg-yellow-300 absolute bottom-0 right-3 -rotate-45 animate-dancing-leg2" data-id="element-734"></div>
              </div>
            </div>
            {/* Shooting Stars */}
            {Array.from({
          length: 5
        }).map((_, i) => <div key={i} className="absolute bg-gradient-to-r from-white via-pink-300 to-transparent w-16 h-0.5 opacity-70 animate-shooting-star" style={{
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 5}s`,
          transform: `rotate(${Math.random() * 360}deg)`
        }} data-id="element-735"></div>)}
          </div>}

        {/* Video Player - Fixed on mobile when active */}
        {activeVideo ? <div className={`${isMobile ? 'fixed top-[80px] left-0 right-0 z-40' : 'relative'} mb-16 rounded-2xl overflow-hidden shadow-2xl shadow-pink-500/20 border border-purple-500/20`} data-id="element-736">
            <div className={`${isMobile ? 'pb-[56.25%] w-[92%] mx-auto' : 'pb-[56.25%]'} h-0 relative`} data-id="element-737">
              <iframe className="absolute top-0 left-0 w-full h-full" src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-738"></iframe>
            </div>
            <button onClick={closeVideo} className="absolute top-4 right-4 bg-black/70 p-2 rounded-full text-white hover:bg-black hover:text-pink-400 transition-all z-10" data-id="element-739">
              <XIcon size={24} data-id="element-740" />
            </button>
          </div> : <div className="mb-16 aspect-video relative rounded-2xl overflow-hidden bg-gradient-to-br from-purple-900/40 to-pink-900/40 border border-purple-500/20 shadow-xl shadow-purple-500/10 flex items-center justify-center" data-id="element-741">
            <div className="text-center p-8" data-id="element-742">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center animate-pulse" data-id="element-743">
                <PlayIcon size={40} className="text-white" data-id="element-744" />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-3" data-id="element-745">
                Experience Our Visual Universe
              </h3>
              <p className="text-gray-300 max-w-lg mx-auto" data-id="element-746">
                Select a visualizer below to immerse yourself in the cosmic
                soundscapes of Fabric Reality
              </p>
            </div>
          </div>}

        {/* Add spacing when video is fixed on mobile */}
        {isMobile && activeVideo && <div className="pb-[56.25%] mb-8" data-id="element-747"></div>}

        {/* Video thumbnails grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-748">
          {displayedVideos.map(video => <div key={video.id} className="group relative overflow-hidden rounded-xl cursor-pointer transform transition-all duration-500 hover:scale-105 hover:shadow-xl hover:shadow-pink-500/20 border border-purple-500/10 hover:border-purple-500/30" onClick={() => handleVideoClick(video.videoUrl)} data-id="element-749">
              <div className="aspect-video bg-black" data-id="element-750">
                <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-751" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex flex-col justify-end p-5" data-id="element-752">
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-753">
                  <div className="w-16 h-16 rounded-full bg-pink-600/90 flex items-center justify-center transform scale-0 group-hover:scale-100 transition-transform duration-500" data-id="element-754">
                    <PlayIcon size={32} className="text-white" data-id="element-755" />
                  </div>
                </div>
                <h3 className="text-lg font-mono text-white mt-auto relative" data-id="element-756">
                  {video.title}
                  <span className="block h-0.5 w-0 bg-gradient-to-r from-pink-500 to-purple-500 group-hover:w-full transition-all duration-500 mt-1" data-id="element-757"></span>
                </h3>
              </div>
            </div>)}
        </div>

        {/* Pagination */}
        {totalPages > 1 && <div className="flex justify-center mt-12 space-x-6" data-id="element-758">
            <button onClick={prevPage} className="p-3 rounded-full bg-purple-900/50 hover:bg-purple-800/70 text-white transition-colors border border-purple-500/30" data-id="element-759">
              <ChevronLeftIcon size={24} data-id="element-760" />
            </button>
            <div className="flex items-center text-white font-mono" data-id="element-761">
              {Array.from({
            length: totalPages
          }).map((_, index) => <button key={index} onClick={() => setCurrentPage(index)} className={`w-3 h-3 rounded-full mx-1 transition-all ${currentPage === index ? 'bg-pink-500 scale-125' : 'bg-white/30 hover:bg-white/50'}`} aria-label={`Go to page ${index + 1}`} data-id="element-762" />)}
            </div>
            <button onClick={nextPage} className="p-3 rounded-full bg-purple-900/50 hover:bg-purple-800/70 text-white transition-colors border border-purple-500/30" data-id="element-763">
              <ChevronRightIcon size={24} data-id="element-764" />
            </button>
          </div>}
      </div>

      {/* Animation Keyframes */}
      <style jsx data-id="element-765">{`
        @keyframes spaceship1 {
          0% {
            transform: translate(-100px, 100px) rotate(30deg);
            opacity: 0;
          }
          20% {
            opacity: 0.7;
          }
          80% {
            opacity: 0.7;
          }
          100% {
            transform: translate(calc(100vw + 100px), 300px) rotate(30deg);
            opacity: 0;
          }
        }
        @keyframes spaceship2 {
          0% {
            transform: translate(-50px, 200px) rotate(-15deg);
            opacity: 0;
          }
          20% {
            opacity: 0.7;
          }
          80% {
            opacity: 0.7;
          }
          100% {
            transform: translate(calc(100vw + 50px), 50px) rotate(-15deg);
            opacity: 0;
          }
        }
        @keyframes alien1 {
          0% {
            transform: translate(calc(100vw + 50px), 150px) scale(0.8);
            opacity: 0;
          }
          20% {
            opacity: 0.8;
          }
          80% {
            opacity: 0.8;
          }
          100% {
            transform: translate(-100px, 300px) scale(1.2);
            opacity: 0;
          }
        }
        @keyframes alien2 {
          0% {
            transform: translate(calc(100vw + 70px), 350px) scale(1);
            opacity: 0;
          }
          20% {
            opacity: 0.8;
          }
          80% {
            opacity: 0.8;
          }
          100% {
            transform: translate(-70px, 100px) scale(0.7);
            opacity: 0;
          }
        }
        @keyframes dancer {
          0% {
            transform: translate(50%, -50px) scale(0.8);
            opacity: 0;
          }
          10% {
            opacity: 0.9;
          }
          90% {
            opacity: 0.9;
          }
          100% {
            transform: translate(50%, 100vh) scale(1.2);
            opacity: 0;
          }
        }
        @keyframes dancing-arm1 {
          0%,
          100% {
            transform: rotate(45deg);
          }
          50% {
            transform: rotate(90deg);
          }
        }
        @keyframes dancing-arm2 {
          0%,
          100% {
            transform: rotate(-45deg);
          }
          50% {
            transform: rotate(-90deg);
          }
        }
        @keyframes dancing-leg1 {
          0%,
          100% {
            transform: rotate(45deg);
          }
          50% {
            transform: rotate(20deg);
          }
        }
        @keyframes dancing-leg2 {
          0%,
          100% {
            transform: rotate(-45deg);
          }
          50% {
            transform: rotate(-20deg);
          }
        }
        @keyframes shooting-star {
          0% {
            transform: translateX(-100px) translateY(0)
              rotate(var(--rotation, 20deg));
            opacity: 0;
          }
          50% {
            opacity: 0.8;
          }
          100% {
            transform: translateX(calc(100vw + 100px)) translateY(100px)
              rotate(var(--rotation, 20deg));
            opacity: 0;
          }
        }
        .animate-spaceship1 {
          animation: spaceship1 8s linear forwards;
        }
        .animate-spaceship2 {
          animation: spaceship2 6s linear forwards;
          animation-delay: 1s;
        }
        .animate-alien1 {
          animation: alien1 7s linear forwards;
          animation-delay: 0.5s;
        }
        .animate-alien2 {
          animation: alien2 9s linear forwards;
          animation-delay: 2s;
        }
        .animate-dancer {
          animation: dancer 10s linear forwards;
        }
        .animate-dancing-arm1 {
          animation: dancing-arm1 0.5s ease-in-out infinite;
        }
        .animate-dancing-arm2 {
          animation: dancing-arm2 0.5s ease-in-out infinite;
          animation-delay: 0.25s;
        }
        .animate-dancing-leg1 {
          animation: dancing-leg1 0.5s ease-in-out infinite;
        }
        .animate-dancing-leg2 {
          animation: dancing-leg2 0.5s ease-in-out infinite;
          animation-delay: 0.25s;
        }
        .animate-shooting-star {
          animation: shooting-star 3s linear forwards;
        }
      `}</style>
    </section>;
};
export default Visualisers;